import * as React from 'react';
import Jumbotron from './Jumbotron';
import WhyMingl from './WhyMingl';
import VideoPromotion from './VideoPromotion';
import Testemonials from './Testemonials';
import FrequentlyAskedQuestions from './FAQ';
import TeamSection from './TeamSection';
import Footer from '../Footer';

export default function MarketingPageContent() {
  return (
    <div className="white bg-mingl-blue center no-margin-collapse">
      <Jumbotron />

      <WhyMingl />

      <VideoPromotion />

      <Testemonials />

      <FrequentlyAskedQuestions />

      <TeamSection />

      <Footer />
    </div>
  );
}
